import axios from "axios";
import { CLEAR_SINGLE_APPLICATION_DATA, ERROR, GET_APPLICATIONS, GET_BORROWER_OCR_DOCS, GET_COBORROWER_OCR_DOCS, GET_LOANS, GET_SINGLE_APPLICATION, LOADER, SET_CURRENT_APPLICATION_ID, SET_COBORROWER_DOC_ERROR, SET_COBORROWER_DOC_LOADING, SET_COBORROWER_DOC_SUCCESS, SET_DOC_ERROR, SET_DOC_SUCCESS, SET_DOC_LOADING, GET_APPLICATION_STATUS_LIST, GET_AUDIT_TRAIL_FOR_APPLICATION, GET_APPLICATIONS_SUMMARY_VIEWS, GET_DELETED_APPLICATIONS, TOKEN_FETCH_ERROR, GET_POST_SANCTION_DOCUMENT_PROCESSING_QUEUE, } from "../actionType";
import { toast } from "react-toastify";
import { getDocKey, getViewSingleDocumentUrl } from "../../utils/docUtils";
import { getAuthHeaders, getAuthToken } from "../../utils/auth";
import { populateFiltersIntoQueryParams } from "../../utils/common";

export const setCurrentApplicationId = (id) => (dispatch) => {
  dispatch({ type: SET_CURRENT_APPLICATION_ID, payload: id });
};

export const clearSingleApplicationData = (dispatch) =>
  dispatch({ type: CLEAR_SINGLE_APPLICATION_DATA });

export const getAllApplications =
  (page, limit, filters) => async (dispatch, getState) => {
    // let tokens = JSON.parse(sessionStorage.getItem('tokens')) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
      dispatch({ type: ERROR });
      return;
    }

    let headers = {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json',
    };

    try {
      dispatch({ type: LOADER });

      let apiFilters = { ...filters };

      if (apiFilters.global_search) {
        const queryStr = apiFilters.global_search.trim();
        const lowerQuery = queryStr.toLowerCase();

        const uuidRegex =
          /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        const isApplicationId = uuidRegex.test(queryStr);

        if (isApplicationId) {
          apiFilters.application_id = queryStr;
          apiFilters.seeds_id = '';
        } else if (/^sfc\d{1,5}$/i.test(queryStr)) {
          // It's an RO ID like SFC00012
          apiFilters.ro_id = queryStr.toUpperCase();
          apiFilters.seeds_id = '';
        } else if (/^(sfc|app|seeds|sfl)\d{6,}$/i.test(queryStr)) {
          // It's an Application Number like SFC00000428
          apiFilters.seeds_id = queryStr.toUpperCase();
          apiFilters.application_id = '';
          apiFilters.branch_name = '';
          apiFilters.branch_code = '';
        } else {
          // Try to match as branch name/code
          let activeBranches = [];
          try {
            const response = await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/officer/get-branch-report?page=1&limit=2000`,
              { headers },
            );
            activeBranches = response?.data?.data?.branch_data || [];
          } catch (e) {
            console.error('Failed to fetch branches in Applications thunk', e);
          }

          const exactMatches = activeBranches.filter(
            (b) =>
              (b.branch_name &&
                b.branch_name.trim().toLowerCase() === lowerQuery) ||
              (b.branch_code &&
                b.branch_code.trim().toLowerCase() === lowerQuery),
          );

          let matchedBranch =
            exactMatches.length === 1 ? exactMatches[0] : null;

          if (!matchedBranch && lowerQuery.length >= 3) {
            const partialMatches = activeBranches.filter(
              (b) =>
                (b.branch_name &&
                  b.branch_name.trim().toLowerCase().includes(lowerQuery)) ||
                (b.branch_code &&
                  b.branch_code.trim().toLowerCase().includes(lowerQuery)),
            );
            if (partialMatches.length === 1) {
              matchedBranch = partialMatches[0];
            }
          }

          if (matchedBranch) {
            // Matched a branch - convert to branch search
            apiFilters.branch_name = matchedBranch.branch_name;
            apiFilters.branch_code = matchedBranch.branch_code || '';
            apiFilters.seeds_id = '';
            apiFilters.application_id = '';
            apiFilters.parent_stage_name = '';
            apiFilters.application_stage_name = '';
          } else {
            // Check if it matches Application Number (seeds_id) format (e.g. contains hyphens or starts with typical prefixes)
            if (/^(sfc|app|seeds|sfl)[-]/i.test(queryStr) || queryStr.includes('-')) {
              apiFilters.seeds_id = queryStr.toUpperCase();
              apiFilters.application_id = '';
              apiFilters.branch_name = '';
              apiFilters.branch_code = '';
            } else {
              // No specialized match - treat as global search
              apiFilters.global_search = queryStr;
              apiFilters.seeds_id = '';
              apiFilters.application_id = '';
              apiFilters.branch_name = '';
              apiFilters.branch_code = '';
            }
          }
        }
        delete apiFilters.global_search;
      }

      // OFFICER_APPLICATION_FILTERS is shared with the Branch/Team screens, which
      // call a different endpoint. Its Customer Name and Customer ID keys are that
      // endpoint's vocabulary; /applications/get-all-applications calls the same
      // two filters `name` and `customer_id`, and ignored the config's keys
      // outright - so both filters silently did nothing here.
      if (apiFilters.customer_name) {
        apiFilters.name = apiFilters.customer_name;
      }
      if (apiFilters.external_customer_id) {
        apiFilters.customer_id = apiFilters.external_customer_id;
      }
      delete apiFilters.customer_name;
      delete apiFilters.external_customer_id;

      if (apiFilters.seeds_id) {
        apiFilters.seeds_id = apiFilters.seeds_id.trim().toUpperCase();
      }
      if (apiFilters.ro_id) {
        apiFilters.ro_id = apiFilters.ro_id.trim().toUpperCase();
      }

      if (apiFilters.end_date && !apiFilters.start_date) {
        toast.info("Please select a application creation start date");
        return;
      }

      if (apiFilters.rejected_end_date && !apiFilters.rejected_start_date) {
        toast.info("Please select a rejection start date");
        return;
      }

      const queryParams = new URLSearchParams({
        page,
        limit,
        filters: JSON.stringify(apiFilters),
      });

      let response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/applications/get-all-applications?${queryParams.toString()}`,
        { headers },
      );
      // console.log("Response ====>", response?.data?.data);

      dispatch({ type: GET_APPLICATIONS, payload: response?.data?.data })

      sessionStorage.setItem('totalPages', response?.data?.data?.pagination?.totalPages || 1);
      sessionStorage.setItem('totalCount', response?.data?.data?.pagination?.total || 0);
      sessionStorage.setItem('currentPage', response?.data?.data?.pagination?.page || 1);
      sessionStorage.setItem('limit', response?.data?.data?.pagination?.limit || 10);
    }
    catch (err) {
      dispatch({ type: ERROR });
      let errorMsg = err?.response?.data?.message || "Error in fetching all applications";
      toast.error(errorMsg);
    }
  };

export const getSingleApplicationData = (id) => async (dispatch) => {
  // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  // let authToken = tokens?.token || null;
  let authToken = getAuthToken();

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  const headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  dispatch({ type: LOADER });
  await axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/applications/get-one/${id}`, {
      headers,
    })
    .then((res) => {
      // console.log("single appln =====>", res?.data?.data);
      dispatch({ type: GET_SINGLE_APPLICATION, payload: res?.data?.data });
    })
    .catch((err) => {
      dispatch({ type: ERROR });
      toast.error(err);
    });
};

export const getLoansByApplicationId = (applicationId) => async (dispatch) => {
  // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  // let authToken = tokens?.token || null;
  let authToken = getAuthToken();

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  const headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  dispatch({ type: LOADER });
  await axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/loans/get-loans?application_id=${applicationId}`,
      { headers },
    )
    .then((res) => {
      // console.log("loans =====>", res?.data?.data);
      dispatch({ type: GET_LOANS, payload: res?.data?.data });
    })
    .catch((err) => {
      dispatch({ type: ERROR });
      toast.error(err);
    });
};

export const fetchOCRDocs = (ocrDocs, applicant) => async (dispatch) => {
  if (!ocrDocs?.length || !['borrower', 'coborrower'].includes(applicant))
    return;

  // let ocrDocuments = {
  //     cbReport: null,
  //     aadharCard: null,
  //     panCard: null,
  //     voterId: null,
  //     drivingLicense: null,
  //     otherKyc: null
  // };

  // if(ocrDocs?.length > 0){
  for (let docItem of ocrDocs) {
    const docKey = getDocKey(docItem?.document_sub_type);
    if (!docKey) continue;

    // dispatch({ type: SET_COBORROWER_DOC_LOADING, payload: { docKey } });

    dispatch({ type: SET_DOC_LOADING, payload: { applicant, docKey } });

    try {
      let fetchedDoc = await getViewSingleDocumentUrl(docItem);

      // dispatch({
      //     type: SET_COBORROWER_DOC_SUCCESS,
      //     payload: { docKey, docData: fetchedDoc }
      //   });

      dispatch({
        type: SET_DOC_SUCCESS,
        payload: { applicant, docKey, docData: fetchedDoc },
      });

      // if(docItem?.document_sub_type === "aadhaar" || docItem?.document_sub_type === "aadhaar-cob"){
      //     ocrDocuments = {
      //         ...ocrDocuments,
      //         aadharCard: fetchedDoc
      //     };
      // }
      // else if(docItem?.document_sub_type === "pan" || docItem?.document_sub_type === "pan-cob"){
      //     ocrDocuments = {
      //         ...ocrDocuments,
      //         panCard: fetchedDoc
      //     }
      // }
      // else if(docItem?.document_sub_type === "other-kyc" || docItem?.document_sub_type === "other-kyc-cob"){
      //     ocrDocuments = {
      //         ...ocrDocuments,
      //         otherKyc: fetchedDoc
      //     }
      // }
      // else if(docItem?.document_sub_type === "voters-id" || docItem?.document_sub_type === "voters-id-cob"){
      //     ocrDocuments = {
      //         ...ocrDocuments,
      //         voterId: fetchedDoc
      //     }
      // }
      // else if(docItem?.document_sub_type === "driving-license" || docItem?.document_sub_type === "driving-license-cob"){
      //     ocrDocuments = {
      //         ...ocrDocuments,
      //         drivingLicense: fetchedDoc
      //     }
      // }
      // else if(docItem?.document_sub_type === "cb-report" || docItem?.document_sub_type === "cb-report-cob"){
      //     ocrDocuments = {
      //         ...ocrDocuments,
      //         cbReport: fetchedDoc
      //     }
      // }
    } catch (err) {
      // console.error("Error fetching document URL:", err);
      // dispatch({ type: ERROR });

      // console.error("Error fetching", docKey, err);

      // dispatch({
      //     type: SET_COBORROWER_DOC_ERROR,
      //     payload: { docKey, error: err.message || "Failed to fetch" }
      // });

      console.error(`Error fetching `, docKey, ` for `, applicant, `: `, err);
      dispatch({
        type: SET_DOC_ERROR,
        payload: { applicant, docKey, error: err.message || 'Failed to fetch' },
      });
    }
  }

  // dispatch({ type: OCR_DOCS_LOADED });

  // if(applicant === "borrower"){
  //     dispatch({ type: GET_BORROWER_OCR_DOCS, payload: ocrDocuments });
  // }
  // else if(applicant === "coborrower"){
  //     dispatch({ type: GET_COBORROWER_OCR_DOCS, payload: ocrDocuments });
  // }
  // }
};

export const getApplicationStatusList = (filters) => async (dispatch) => {
  // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  // let authToken = tokens?.token || null;
  let authToken = getAuthToken();

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams();

    if (filters?.parent_stage_name) {
      queryParams.append('parent_stage_name', filters?.parent_stage_name);
    }

    if (filters?.application_stage_name) {
      queryParams.append(
        'application_stage_name',
        filters?.application_stage_name,
      );
    }

    if (filters?.is_active) {
      queryParams.append('is_active', filters?.is_active);
    }

    let response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/application-status/get-application-status?${queryParams.toString()}`,
      { headers },
    );
    // console.log("Response ====>", response?.data?.data);

    dispatch({
      type: GET_APPLICATION_STATUS_LIST,
      payload: response?.data?.data,
    });
  } catch (err) {
    dispatch({ type: ERROR });
    toast.error('Error in fetching application status list', err);
  }
};

export const getAuditTrailForApplication = (page, limit, filters) => async (dispatch) => {
  // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  // let authToken = tokens?.token || null;
  let authToken = getAuthToken();

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams({
      page,
      per_page: limit,
    });

    if (filters?.application_id) {
      queryParams.append('application_id', filters?.application_id);
    }

    if (filters?.action) {
      queryParams.append('action', filters?.action);
    }

    if (filters?.action_by_type) {
      queryParams.append('action_by_type', filters?.action_by_type);
    }

    if (filters?.action_type) {
      queryParams.append('action_type', filters?.action_type);
    }

    if (filters?.officer_id) {
      queryParams.append('officer_id', filters?.officer_id);
    }

    if (filters?.from_date) {
      queryParams.append('from_date', filters?.from_date);
    }

    if (filters?.to_date) {
      queryParams.append('to_date', filters?.to_date);
    }

    if (filters?.splitter) {
      queryParams.append('splitter', filters?.splitter);
    }

    if (filters?.order) {
      queryParams.append('order', filters?.order);
    }

    if (filters?.search) {
      queryParams.append('search', filters?.search);
    }

    if (filters?.category) {
      queryParams.append('category', filters?.category);
    }

    let response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/applications/history/${filters.application_id}?${queryParams.toString()}`,
      { headers },
    );

    dispatch({
      type: GET_AUDIT_TRAIL_FOR_APPLICATION,
      payload: response?.data?.data,
    });

    sessionStorage.setItem(
      'totalPages',
      response?.data?.data?.pagination?.total_pages || 1,
    );
    sessionStorage.setItem(
      'totalCount',
      response?.data?.data?.pagination?.total_records || 0,
    );
    sessionStorage.setItem(
      'currentPage',
      response?.data?.data?.pagination?.current_page || 1,
    );
    sessionStorage.setItem(
      'limit',
      response?.data?.data?.pagination?.per_page || 10,
    );
  } catch (err) {
    dispatch({ type: ERROR });
    toast.error('Error in fetching application history', err);
  }
};

export const getApplicationDashbordSummary = (clientId, moduleType, filters = {}) => async (dispatch) => {
  // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  // let authToken = tokens?.token || null;
  let authToken = getAuthToken();

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    Authorization: `Bearer ${authToken}`,
    'Content-Type': 'application/json',
  };

  try {
    dispatch({ type: LOADER });

    const queryParams = new URLSearchParams();

    if (filters.display_name) {
      queryParams.append('display_name', filters?.display_name);
    }

    if (filters.is_active) {
      queryParams.append('is_active', filters?.is_active);
    }

    let response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/views/get-views/${clientId}/${moduleType}?${queryParams.toString()}`,
      { headers },
    );
    dispatch({
      type: GET_APPLICATIONS_SUMMARY_VIEWS,
      payload: response?.data?.data,
    });
  } catch (err) {
    dispatch({ type: ERROR });
    toast.error('Error in fetching application summary views', err);
  }
}

export const getDeletedApplications = (page, limit, filters) => async (dispatch) => {
  // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
  // let authToken = tokens?.token || null;
  let authToken = getAuthToken();

  if (!authToken) {
    dispatch({ type: ERROR });
    return;
  }

  let headers = {
    'Authorization': `Bearer ${authToken}`,
    'Content-Type': 'application/json'
  }

  try {
    dispatch({ type: LOADER });

    let cleanFilters = { ...filters };
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

    if (cleanFilters.application_id) {
      const trimmed = cleanFilters.application_id.trim();
      if (trimmed && !uuidRegex.test(trimmed) && !/^sfc/i.test(trimmed) && !trimmed.includes("...")) {
        cleanFilters.application_id = "INVALID_EXPECTS_ZERO_RESULTS";
      }
    }
    if (cleanFilters.seeds_id) {
      const trimmed = cleanFilters.seeds_id.trim();
      if (trimmed && !uuidRegex.test(trimmed) && !/^sfc/i.test(trimmed) && !trimmed.includes("...")) {
        cleanFilters.seeds_id = "INVALID_EXPECTS_ZERO_RESULTS";
      }
    }

    const queryParams = new URLSearchParams({
      page,
      limit
    });

    Object.entries(cleanFilters).forEach(([key, value]) => {
      // Handle boolean values
      if (typeof value === "boolean") {
        queryParams.append(key, value);
        return;
      }

      // Handle arrays (multiselects)
      if (Array.isArray(value)) {
        value.forEach(val => {
          if (val) {
            queryParams.append(key, val);
          }
        });
        return;
      }

      // Handle normal values
      if (value !== null && value !== undefined && value !== "") {
        queryParams.append(key, value);
      }
    });

    let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/applications/get-deleted-applications?${queryParams.toString()}`, { headers });
    // console.log("Response ====>", response?.data?.data);

    dispatch({ type: GET_DELETED_APPLICATIONS, payload: response?.data?.data })

    sessionStorage.setItem('totalPages', response?.data?.data?.pagination?.totalPages || 1);
    sessionStorage.setItem('totalCount', response?.data?.data?.pagination?.total || 0);
    sessionStorage.setItem('currentPage', response?.data?.data?.pagination?.page || 1);
    sessionStorage.setItem('limit', response?.data?.data?.pagination?.limit || 10);
  }
  catch (err) {
    dispatch({ type: ERROR });
    let errorMsg = err?.response?.data?.message || err?.message || 'Error in fetching all deleted applications';
    toast.error(errorMsg);
  }
}

export const getPostSanctionDocumentProcessingQueue = (page, limit, filters) => async (dispatch) => {
  try {
    const token = getAuthToken();

    if (!token) {
      dispatch({ type: TOKEN_FETCH_ERROR });
      return;
    }

    console.log({ filters });
    let filteredQueryParams = populateFiltersIntoQueryParams(filters);
    console.log({ filteredQueryParams });

    let response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/sanction/get-manual-document-process?${filteredQueryParams.toString()}`,
      { headers: getAuthHeaders() }
    );

    dispatch({
      type: GET_POST_SANCTION_DOCUMENT_PROCESSING_QUEUE,
      payload: response?.data?.data,
    });
  }
  catch (error) {
    let errorMsg = error?.response?.data?.message;
    dispatch({ type: ERROR, payload: errorMsg });
    toast.error(errorMsg);
  }
}